<div class="add-to-inventory">

  <div class="add-inventory-header-body">
    <div class="inventory-header mr-3">
      <div class="header-icon mr-3">
        <i *ngIf="dialogType === 'inventory'" class="fas fa-boxes icon-boxes"></i>
        <i *ngIf="dialogType === 'return'" class="fas fa-undo icon-boxes"></i>
      </div>

      <div class="header-text flex-column flex-center-center">
        <span *ngIf="dialogType === 'inventory'" class="main-text">Add to inventory</span>
        <span *ngIf="dialogType === 'return'" class="main-text">Return tracking</span>

        <div *ngIf="dialogType === 'inventory'" class="header-subtext">
          <span class="sub-text">Add the item to catalogue first and set location to proceed</span>
        </div>
      </div>
    </div>

    <div class="close-icon flex-around-center pointer" (click)="handleClose()">
      <i class="fa fa-times font-400 font-20"></i>
    </div>
  </div>

  <div class="add-inventory-body-wrapper">
    <div class="add-inventory-body mb-2">
      <div class="inventory-part-wrapper">
        <span class="show-box"></span>

        <div class="inventory-part pl-2">
          <div class="inventory-item flex-between-center">
            <!-- Item name -->
            <div class="flex-start-center">
              <i class="fal fa-tools font-16 font-400 tool-icon pr-2"></i>
              <span class="item-name">{{inventoryItem?.title}}</span>
            </div>

            <div class="flex-end-center">
              <!-- Item quantity -->
              <div class="qty-section mr-4">
                <div class="service-qty-section">
                  <i class="fal fa-boxes inventory-boxes"></i>

                  <div class="service-qty pl-3">
                    <span class="service-label">Service qty</span>
                    <span class="qty-label">{{inventoryItem?.count | number: '1.2-2'}}</span>
                  </div>
                </div>
              </div>

              <!-- Item total cost -->
              <div class="qty-section mr-4">
                <div class="service-qty-section">
                  <i class="fal fa-receipt inventory-boxes"></i>

                  <div class="service-qty pl-2">
                    <span *ngIf="dialogType === 'inventory'" class="service-label">Total Cost</span>
                    <span *ngIf="dialogType === 'return'" class="service-label">Cost/unit</span>
                    <span *ngIf="dialogType === 'inventory'" class="qty-label">
                      {{inventoryItem?.totalCost | currency: usd}}
                    </span>
                    <span *ngIf="dialogType === 'return'" class="qty-label">
                      {{inventoryItem?.cost | currency: usd}}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Item location -->
              <div *ngIf="dialogType === 'inventory'" class="qty-section">
                <div class="service-qty-section">
                  <i class="fal fa-map-pin inventory-boxes map-pin-icon"></i>
                  <div class="service-qty">
                    <span class="service-label">Location</span>
                    <span [pTooltip]="inventoryItem?.location?.name" class="qty-label text-truncate">{{inventoryItem?.location?.name}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Item cart -->
      <div class="invoice-section-wrapper width-100p">
        <div *ngFor="let orderedItem of orderedItems;" class="mt-3">
          <div class="invoice-section mt-3">
            <!-- Cart header -->
            <div class="supplier-section flex-start-center">
              <!-- Cart header left -->
              <div class="supplier-box flex-start-center w-100">
                <!-- Checkbox -->
                <div class="supplier-checkbox mr-2">
                  <app-checkbox inputId="item-invoice-{{orderedItem?._id}}" fontSize="18"
                    [disabled]="orderedItem.isConsumed" [isChecked]="orderedItem.isConsumed || orderedItem?.selected"
                    (appChange)="handleChange('selected', orderedItem, $event)">
                  </app-checkbox>
                </div>

                <!-- Supplier invoice # -->
                <div class="supplier-detail flex-column">
                  <span class="text-supplier">Supplier&nbsp;invoice&nbsp;#</span>
                  <span class="invoice-number">{{orderedItem?.supplierInvoicedNo}}</span>
                </div>
                <div class="supplier-detail flex-column ml-3" *ngIf="orderedItem?.poNumber">
                  <span class="text-supplier">PO&nbsp;#</span>
                  <span class="invoice-number">{{orderedItem?.poNumber}}</span>
                </div>
              </div>

              <!-- Cart header right -->
              <div class="invoice-detail-section flex-end-center">
                <!-- Supplier -->
                <div class="supplier-badge flex-center-center mr-2">
                  <span class="supplier-badge-text pr-2">Supplier</span>
                  <span class="supplier-badge-text text-truncate value font-600"
                    [pTooltip]="orderedItem?.supplier?.name">{{orderedItem?.supplier?.name}}</span>
                </div>

                <!-- Cost -->
                <div class="cost-badge flex-center-center mr-2">
                  <span class="cost-badge-text pr-2">Cost</span>
                  <span class="cost-badge-text font-600">{{orderedItem?.cost | currency: usd}}</span>
                </div>

                <div class="times-box mr-2">
                  <i class="fa fa-times"></i>
                </div>

                <!-- Quantity -->
                <div class="quantity-badge flex-center-center mr-2">
                  <span class="quantity-badge-text pr-2">Qty&nbsp;ordered</span>
                  <span class="quantity-badge-text font-600">{{orderedItem?.quantity | number: '1.2-2'}}</span>
                </div>

                <div class="equal-box mr-2">
                  <i class="fa fa-equals"></i>
                </div>

                <!-- Total cost -->
                <div class="total-cost-badge flex-center-center">
                  <span class="total-cost-text pr-2">Total&nbsp;Cost</span>
                  <span class="total-cost-text font-600">{{orderedItem?.totalCost | currency: usd}}</span>
                </div>
              </div>
            </div>

            <!-- Cart body -->
            <div class="items-inventory-section flex-between-center">
              <div class="input-inventory-item-wrapper flex-start-center">
                <div class="flex-start-center" [ngClass]="{'w-50': dialogType === 'return'}">
                  <i class="far fa-boxes font-gray-45 input-icon flex-center-center mr-2"></i>

                  <div class="w-100 mr-3">
                    <app-input *ngIf="dialogType === 'inventory'" id="part-qty-inventory-{{orderedItem?._id}}"
                      type="text" placeholder="Qty add to inventory" [fontSize]="14" [floatingLabel]="true"
                      [isInvalid]="orderedItem?.qtyAddedToInventoryIsInvalid" [selectTextOnFocus]="true" mask="0*"
                      [errorMessage]="orderedItem?.qtyAddedToInventoryError" [value]="orderedItem?.totalQtyStocked"
                      [disabled]="orderedItem.isConsumed || !orderedItem?.selected || orderedItem.itemSelected" [allowDecimal]="true"
                      (appFocus)="orderedItem.qtyAddedToInventoryError = '';orderedItem.qtyAddedToInventoryIsInvalid = false"
                      (appChange)="handleChange('totalQtyStocked', orderedItem, $event)">
                    </app-input>

                    <app-input *ngIf="dialogType === 'return'" id="part-qty-returned-{{orderedItem?._id}}" type="text"
                      placeholder="Qty returned" [fontSize]="14" [floatingLabel]="true"
                      [isInvalid]="orderedItem?.qtyReturnedIsInvalid" [value]="orderedItem?.itemReturnQty"
                      [disabled]="orderedItem.isConsumed || !orderedItem?.selected || orderedItem.itemSelected" [selectTextOnFocus]="true"
                      [errorMessage]="orderedItem?.qtyReturnedError" [allowDecimal]="false" mask="0*"
                      (appChange)="handleChange('itemReturnQty', orderedItem, $event)">
                    </app-input>
                  </div>
                </div>

                <div *ngIf="dialogType === 'return'" class="flex-start-center return-date position-relative"
                  [ngClass]="{'w-50': dialogType === 'return'}">
                  <i class="far fa-calendar-alt font-gray-45 input-icon flex-center-center mr-2"></i>
                  <span class="return-date-label">Return date</span>

                  <div class="w-100 calendar-input core-calendar">
                    <p-calendar id="return-date-{{orderedItem?._id}}" dateFormat="M dd, yy"
                      [(ngModel)]="orderedItem.returnDate" [disabled]="orderedItem.isConsumed || !orderedItem?.selected"
                      #startDateCalendar>
                    </p-calendar>
                  </div>
                </div>
              </div>

              <div class="qty-returned-section">
                <div class="inventory-item-qty flex-between-center">
                  <span class="qty-text mr-3">Qty already returned</span>
                  <span class="item-qty-returned">
                    {{ orderedItem?.qtyReturned || 0 }} / {{ orderedItem?.quantity}}
                  </span>
                </div>

                <div class="inventory-item-qty flex-between-center">
                  <span class="qty-text mr-3">Qty added to inventory</span>
                  <span class="item-qty-returned">
                    {{ orderedItem?.qtyAddedToInventory || 0 }} / {{ orderedItem?.quantity}}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="add-inventory-footer flex-end-center">
    <button class="btn btn-border btn-submit btn-white pointer mr-1" [disabled]="isSaving || isLoading"
      (click)="handleClose()">
      <span class="font-14 font-700">{{cancelBtnLablel}}</span>
    </button>

    <button class="btn btn-primary pointer" [disabled]="isSaving || isLoading || !orderedItems?.length" (click)="handleSubmit()">
      <span class="font-14 font-700">
        {{saveBtnLable}}
        <i *ngIf="isSaving" class="fal fa-spinner rotate ml-2"></i>
      </span>
    </button>
  </div>
</div>
